import React from "react";
import { GiPodium } from "react-icons/gi";

function ResultsEmptyState({ hasFilters, onReset }) {
  return (
    <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white p-8 text-center shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[1.5rem] bg-orange-100 text-3xl text-orange-600 dark:bg-orange-500/10 dark:text-orange-200">
        <GiPodium />
      </div>

      <h2 className="mt-5 font-titre text-2xl font-bold text-slate-950 dark:text-white">
        Aucun résultat trouvé
      </h2>

      <p className="mx-auto mt-3 max-w-xl text-sm font-medium leading-7 text-slate-500 dark:text-white/50">
        {hasFilters
          ? "Aucun résultat ne correspond aux filtres actuels."
          : "Aucune compétition n'a été trouvée pour les judokas inscrits dans tes groupes."}
      </p>

      {hasFilters && (
        <button
          type="button"
          onClick={onReset}
          className="mt-5 inline-flex min-h-11 items-center justify-center rounded-2xl bg-orange-500 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-orange-600"
        >
          Réinitialiser les filtres
        </button>
      )}
    </div>
  );
}

export default ResultsEmptyState;